<template>
	<div class="form-group">
		<label v-if="field.question">
			{{ field.question }}
			<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
		</label>
        <small 
        v-if="requiredIncomplete"
        class="ml-1" style="color:#FF0000"    
    >{{  $t('required')}}</small>
		<div v-if="field.description" v-html="field.description"></div>
		<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		<VueSignaturePad 
		width="100%" 
		height="500px" 
		ref="signaturePad" 
		style="border:1px solid black; max-width: 800px;" 
		:options="{ onBegin, onEnd }"
		/>
		<button class="btn btn-light mt-2" @click="clear" v-if="!readonly">{{$t('clear')}}</button>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
		clear() {
			this.$refs.signaturePad.clearSignature();
			this.field.value = null;
		},
	    onBegin() {
	    },
	    onEnd() {
			const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			if(!isEmpty) {
				this.field.value = data;
			}
	    },
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
	},
	watch: {
		readonly: function () {
			if(this.readonly) {
				this.$refs.signaturePad.lockSignaturePad();
			} else {
				this.$refs.signaturePad.openSignaturePad();
			}
		}
	},	
	mounted() {
		if(this.field.value) {
			this.$refs.signaturePad.fromDataURL(this.field.value)
		}
		if(this.readonly) {
			this.$refs.signaturePad.lockSignaturePad();
		} else {
			this.$refs.signaturePad.openSignaturePad();
		}		
	},
    computed:{
        requiredIncomplete() {
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && !this.field.value;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    }
};
</script>
